import { render } from "./preferences.vue?vue&type=template&id=7a3ae4bd&scoped=true"
import script from "./preferences.vue?vue&type=script&lang=js"
export * from "./preferences.vue?vue&type=script&lang=js"

import "./preferences.vue?vue&type=style&index=0&id=7a3ae4bd&lang=scss"
import "./preferences.vue?vue&type=style&index=1&id=7a3ae4bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3ae4bd"],['__file',"src/views/account_center/components/preferences.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a3ae4bd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a3ae4bd', __exports__)) {
    api.reload('7a3ae4bd', __exports__)
  }
  
  module.hot.accept("./preferences.vue?vue&type=template&id=7a3ae4bd&scoped=true", () => {
    api.rerender('7a3ae4bd', render)
  })

}


export default __exports__